// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconArrowsArrowOutlineActuallyCentredDown_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 4.46969L6.46973 2L7.53039 3.06066L4.00003 6.59101L0.469727 3.0607L1.53039 2.00004L4.00004 4.46969Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00004 6.46969L8.96973 3.5L10.0304 4.56066L6.00003 8.59102L1.96973 4.56066L3.03039 3.5L6.00004 6.46969Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00008 9.2929L13.293 4L14.7072 5.41421L8.00008 12.1213L1.29297 5.41421L2.70718 4L8.00008 9.2929Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 14.6161L20.6162 6L22.384 7.76777L12.0001 18.1517L1.61621 7.76777L3.38398 6L12.0001 14.6161Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9999 24.184L30.0605 10.1233L27.9392 8.00195L15.9999 19.9413L4.06053 8.00196L1.93921 10.1233L15.9999 24.184Z" class="svg-bg"/>
</svg>
`;
/**
 * IconArrowsArrowOutlineActuallyCentredDown is a generated icon component.
 */
let IconArrowsArrowOutlineActuallyCentredDown = IconArrowsArrowOutlineActuallyCentredDown_1 = class IconArrowsArrowOutlineActuallyCentredDown extends IconBaseElement {
    render() {
        return html `${IconArrowsArrowOutlineActuallyCentredDown_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconArrowsArrowOutlineActuallyCentredDown.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconArrowsArrowOutlineActuallyCentredDown = IconArrowsArrowOutlineActuallyCentredDown_1 = __decorate([
    customElement('zui-icon-arrows-arrow-outline-actually-centred-down')
], IconArrowsArrowOutlineActuallyCentredDown);
export { IconArrowsArrowOutlineActuallyCentredDown };
